// extracted by mini-css-extract-plugin
export var chevron = "_kd-4";
export var chevronExpanded = "_kd-5";
export var row = "_kd-0";
export var rowBody = "_kd-6";
export var rowDescription = "_kd-7";
export var rowHeader = "_kd-1";
export var rowTitle = "_kd-2";
export var rowTitleComplete = "_kd-3";